import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiCallingService } from "../../services/api-calling.service";
import { Globals } from "../../common/global";
import { ToastrService } from "ngx-toastr";
import { ConfigApi } from "../../config-api";

@Component({
  selector: "app-manage-spot",
  templateUrl: "./manage-spot.component.html",
  styleUrls: ["./manage-spot.component.css"],
})
export class ManageSpotComponent implements OnInit {
  purchaseBookingsList: any = [];
  @ViewChild("deleteBeachModal") deleteBeachModal: any;
  @ViewChild("cancelRequestModal") cancelRequestModal: any;
  @ViewChild("completeBookingModal") completeBookingModal: any;
  @ViewChild("activeBookingModal") activeBookingModal: any;
  @ViewChild("refundBookingModal") refundBookingModal: any;
  @ViewChild("viewDetailsmodal") viewDetailsmodal: any;
  deleteModalId: number | string = "";
  selectedBookingId: number | string = "";
  page: number = 0;
  pageSize: number = 10;
  totalcount: number = 0;
  operator_id!: string;
  operatorDetails: Object = {};
  ListDetails: any[] = [];
  details: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private apiCallingService: ApiCallingService,
    public Globals: Globals,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.operator_id = this.Globals.getUser()._id;
    this.operatorDetails = this.Globals.getOperatorDetails();
    this.getList();
  }

  getList(): void {
    let page = this.page == 0 ? 0 : this.page - 1;

    this.apiCallingService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.SPOT_BOOKING.PURCHASE_BOOKING_LIST +
          "?operator_id=" +
          this.operator_id +
          "&page=" +
          page +
          "&limit=" +
          this.pageSize
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.purchaseBookingsList = res.data;
            this.totalcount = res.total;
          } else {
            console.error(res.msg);
          }
        },
        (err) => {
          this.toastr.error(err.error.msg, "Error");
        }
      );
  }

  editBooking(bookingId: number): void {
    this.router.navigate(["/user/spot-booking/edit", bookingId]);
  }

  deleteBooking(bookingId: number): void {
    this.modalService.open(this.deleteBeachModal, {
      centered: true,
      backdrop: "static",
    });
    this.deleteModalId = bookingId;
  }

  viewBookingDetails(bookingId: number): void {
    this.router.navigate(["/user/manage-spot-details", bookingId]);
    // this.apiCallingService
    //   .callAPI(
    //     {},
    //     "GET",
    //     ConfigApi.URLS.SPOT_BOOKING.PURCHASE_BOOKING_DETAILS + "/" + bookingId
    //   )
    //   .subscribe(
    //     (res) => {
    //       if (this.apiCallingService.handleSuccess(res)) {
    //         this.details = res.data;
    //         console.log(this.details);
    //         this.modalService.open(this.viewDetailsmodal, {
    //           centered: true,
    //           backdrop: "static",
    //           size: "lg",
    //         });
    //       } else {
    //         console.error(res.msg);
    //       }
    //     },
    //     (err) => {
    //       this.toastr.error(err.error.msg, "Error");
    //     }
    //   );
  }

  removeBeach(id: number): void {
    this.apiCallingService
      .callAPI({}, "DELETE", ConfigApi.URLS.SPOT_BOOKING.DELETE + "/" + id)
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.ngOnInit();
            this.toastr.success(res.msg);
            this.modalService.dismissAll();
          }
        },
        (err) => {
          this.ngOnInit();
          this.modalService.dismissAll();
          this.toastr.error(err.error.msg, "Error");
        }
      );
  }

  cancelRequest(bookingId: number | string): void {
    this.selectedBookingId = bookingId;
    this.modalService.open(this.cancelRequestModal, {
      centered: true,
      backdrop: "static",
    });
  }

  completeBooking(bookingId: number | string): void {
    this.selectedBookingId = bookingId;
    this.modalService.open(this.completeBookingModal, {
      centered: true,
      backdrop: "static",
    });
  }

  refundBooking(bookingId: number | string): void {
    this.selectedBookingId = bookingId;
    this.modalService.open(this.refundBookingModal, {
      centered: true,
      backdrop: "static",
    });
  }

  // Confirmation methods
  confirmCancelRequest(): void {
    const payload = {
      status: "cancel_requested",
    };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        ConfigApi.URLS.SPOT_BOOKING.UPDATE_STATUS + "/" + this.selectedBookingId
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Cancel request sent successfully");
            this.getList();
            this.modalService.dismissAll();
          } else {
            this.toastr.error(res.msg || "Failed to send cancel request");
          }
        },
        (err) => {
          this.toastr.error(
            err.error?.msg || "Error sending cancel request",
            "Error"
          );
          this.modalService.dismissAll();
        }
      );
  }

  confirmCompleteBooking(): void {
    const payload = {
      status: "completed",
    };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        ConfigApi.URLS.SPOT_BOOKING.UPDATE_STATUS + "/" + this.selectedBookingId
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Booking completed successfully");
            this.getList();
            this.modalService.dismissAll();
          } else {
            this.toastr.error(res.msg || "Failed to complete booking");
          }
        },
        (err) => {
          this.toastr.error(
            err.error?.msg || "Error completing booking",
            "Error"
          );
          this.modalService.dismissAll();
        }
      );
  }

  confirmActiveBooking(): void {
    const payload = {
      status: "active",
    };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        ConfigApi.URLS.SPOT_BOOKING.UPDATE_STATUS + "/" + this.selectedBookingId
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Booking activated successfully");
            this.getList();
            this.modalService.dismissAll();
          } else {
            this.toastr.error(res.msg || "Failed to activate booking");
          }
        },
        (err) => {
          this.toastr.error(
            err.error?.msg || "Error activating booking",
            "Error"
          );
          this.modalService.dismissAll();
        }
      );
  }

  confirmRefundBooking(): void {
    const payload = {
      status: "refund_requested",
    };

    this.apiCallingService
      .callAPI(
        payload,
        "PUT",
        ConfigApi.URLS.SPOT_BOOKING.REFUND + "/" + this.selectedBookingId
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.toastr.success("Refund request processed successfully");
            this.getList();
            this.modalService.dismissAll();
          } else {
            this.toastr.error(res.msg || "Failed to process refund");
          }
        },
        (err) => {
          this.toastr.error(
            err.error?.msg || "Error processing refund",
            "Error"
          );
          this.modalService.dismissAll();
        }
      );
  }

  // Utility methods
  getAvailableSlots(slots: any[]): number {
    return slots?.filter((slot) => slot.status === "available").length || 0;
  }

  getBookedSlots(slots: any[]): number {
    return slots?.filter((slot) => slot.status === "booked").length || 0;
  }

  loadPage(page: number): void {
    if (page) {
      this.page = page;
      this.getList();
    }
  }
}
